import { BrandingStyle, CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_parse, CCTM_route, CCTM_subnav, NavLink, useCCTM, useModel } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import React, { useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";


/* Context for EDE Statement components. */
const EDEStatementsMainNavViewContext = React.createContext(null);
const useEDEStatementsMainNavViewContext = () => React.useContext(EDEStatementsMainNavViewContext);

/**
 * @name EDEStatementsMainNavView
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for the EDE Statements navigation. The code in this
 * file was copied from component "MainNavView" since the functionality/styles were
 * similar although slightly different enough to warrant a new file.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <EDEStatementsMainNavView />
 *      </div>
 *  );
 * }
 */
export default function EDEStatementsMainNavView(props) {
    const isMobile = props.isMobile ?? false;
    const [ viewProps, setViewProps ] = useState({ isMobile: isMobile });
    const {demos } = useModel();
    const xml =  useCCTM(),
    menu = <CCTM nav-id="edeStatementsMainNav" xml={ xml } self={ MainNavWrapper }>
            <CCTM_nav component={ EDEStatementsMainNavContainer }/>                            
            <CCTM_route component={ MainNavItem } postRender={checkIfSignOut}/>                 
            <CCTM_link component={ MainNavItem } postRender={checkIfSignOut}/>  
            <CCTM_item component={ MainNavItem } postRender={checkIfSignOut}/>    
            <CCTM_items component={ EDEStatementsMainNavContainer }/>                     
            <CCTM_demo component={ MainNavItem } demos={demos}/> 
            <CCTM_subnav component={ DropDownMenu }/>              
        </CCTM>;
    window.edeStatementsMenuXML = xml;
    window.navigate = Util.getClickTrace;

    return (
        <EDEStatementsMainNavViewContext.Provider value={ { viewProps, setViewProps } }>
            { menu }
          
        </EDEStatementsMainNavViewContext.Provider>
    );
}
   function checkIfSignOut(component,data){
    

      
      if(data.id == "edeStatementsMainNav_sign_out" ){
      
         
              return SignOutLink
          
    
     
      
    }
    return component;
  }
/**
 * @name EDEStatementsMainNavContainer
 * @function
 * @extends React.Component
 * @exported false
 * @description A component for the EDE Statements navigation.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <EDEStatementsMainNavContainer />
 *      </div>
 *  );
 * }
 */
function EDEStatementsMainNavContainer(props) {
    const context = useEDEStatementsMainNavViewContext();
    return (
        <BrandingStyle style={{
            "backgroundColor": "navigation_bar_bg_abi22"
        }} className={ `ede-statements-main-nav ${ context.viewProps.isMobile ? "mobile" : "desktop" }` }>       
            <div className={ `flex-container ${ context.viewProps.isMobile ? "flex-vertical" : "flex-horizontal" }` }>
                {props.children}
            </div>     
        </BrandingStyle>
    );
}
 
 function FlyOutMenu(props){
    const {demos } = useModel();
    return <CCTM   xml={props.currentNode} self={SubNavSubItem} data={props.data}>      
                             <CCTM_subnav component={FlyOutMenu}/>   
                             <CCTM_route component={MainNavMenuItem} postRender={checkIfSignOut}/>           
                            <CCTM_link component={MainNavMenuItem} postRender={checkIfSignOut}/> 
                            <CCTM_item component={MainNavMenuItem} postRender={checkIfSignOut}/> 
                            <CCTM_items component={DropDownWrapper}/>                     
                            <CCTM_demo component={MainNavMenuItem} demos={demos}/>                                                   
                        </CCTM>;
}
function DropDownMenu(props){
    const {demos } = useModel();
    return <CCTM xml={props.currentNode} self={MainNavSubItem} data={props.data}>            
                       <CCTM_subnav component={FlyOutMenu}  /> 
                        <CCTM_route component={MainNavMenuItem} postRender={checkIfSignOut}/>              
                        <CCTM_link component={MainNavMenuItem} postRender={checkIfSignOut}/> 
                        <CCTM_item component={MainNavMenuItem} postRender={checkIfSignOut}/> 
                        <CCTM_items component={DropDownWrapper}/>                   
                        <CCTM_demo component={MainNavMenuItem} demos={demos}/>                       
                    </CCTM>;
}

function DropDownWrapper(props) {
    const className = props["custom-class"]?{className:props["custom-class"]}:{};
    return (
        <div  {...className}>           
                {props.children}           
        </div>
    )
}
function MainNavWrapper(props) {
    return (
        <>
            {props.children} 
     
        </>           
                     
     
    )
}

/**
 * @name MainNavItem
 * @function
 * @extends React.Component
 * @exported false
 * @description Main nav item in the *MainNavView* component
 * @param {STRING} label - Text of the the link
 * @param {STRING} route - The route that should occur on click
 * @param {STRING} data-point - The data point that should be added to the MainNavItem
 * @param {React.Component} children - Any child elements
 * @note </br>
 *  - If child elements exist
 *      - The route will be overwritten and only show a dropdown on click
 *      - The link will appear active for all of the child routes
 * @example
 * <MainNavItem label="Link A" route="/Link" />
 * 
 * <MainNavItem label="Link B">
 *  <MainNavMenuItem label="Sub Link A" route="/Path" />
 * </MainNavItem>
 */
function MainNavItem(props) {
   
    const point = props["data-point"] ? props["data-point"] : props.datapoint ?? "";
    const labelDataPoint = point ? { "data-point": `${ point}_Label` } : {};
    const additionalRoutes = props.activeRoutes ?? [];
    const className = props["custom-class"] ?? "";
    const [dropdown, setDropdown] = useState(false);
    const toggleDropdown = () => {
        setDropdown(!dropdown)
    };
let to = props.to;
let onClick = ()=>{};
if(props.onClick){
    to ="";
    onClick= ()=>{
    
        props.onClick()};
}

    const hasChildren = React.Children.count(props.children) > 0;
    let activeRoutes = CCTM_parse.getActiveRoutes(props)

    activeRoutes = activeRoutes.concat(additionalRoutes);
    return (
        <div className={"main-nav-item-view "+className} data-point={point}>
            <NavLink 
                className="main-nav-item"
                to={to}
                onClick={onClick}
                activeRoutes={activeRoutes}
                activeClassName="active-item"
               >
                <span clickable={props.id} { ...labelDataPoint }>{ props.label }</span>
               
            </NavLink>

        </div>
    );
}
function SignOutLink(props) {
   
    const point = props["data-point"] ? props["data-point"] : props.datapoint ?? "";
    const additionalRoutes = props.activeRoutes ?? [];
    const className = props["custom-class"] ?? "";
    const [dropdown, setDropdown] = useState(false);
    const toggleDropdown = () => {
        setDropdown(!dropdown)
    };
let to = '';
let onClick = ()=>{
    if(Util.inMabi) {
        Util.closeWindowInMABI23();
    } else {
        window.close();
    }
};

    const hasChildren = React.Children.count(props.children) > 0;
    let activeRoutes = CCTM_parse.getActiveRoutes(props)

    activeRoutes = activeRoutes.concat(additionalRoutes);
    return (
        <div className={"main-nav-item-view "+className} data-point={point}>
            <NavLink 
                className="main-nav-item"
                to={to}
                onClick={onClick}
                activeRoutes={activeRoutes}
                activeClassName="active-item"
               >
                <span clickable={props.id}>{ props.label }</span>
               
            </NavLink>

        </div>
    );
}
function MainNavSubItem(props) {

    const point = props["data-point"] ? props["data-point"] : props.datapoint ?? "";
    const labelDataPoint = point ? { "data-point": `${ point}_Label` } : {};
    const additionalRoutes = props.activeRoutes ?? [];
    const className = props["custom-class"] ?? "";
    const [dropdown, setDropdown] = useState(false);
    const toggleDropdown = () => setDropdown(!dropdown);
    const menuItemIconDataPoint = point ? { "data-point": `${ point }_Menu_Item_Icon` } : {}

    let activeRoutes =CCTM_parse.getActiveRoutes(props)

    const hasChildren = React.Children.count(props.children) > 0;
    if(activeRoutes.indexOf("/transferActivity/scheduledTransfers") >0){
        activeRoutes = activeRoutes.concat("/transferActivity/transferHistory");
    }else{
        if(activeRoutes.indexOf("/transferActivity/transferHistory") >0){
            activeRoutes = activeRoutes.concat("/transferActivity/scheduledTransfers");
        }
    }
    
    const handleOnClick = evt => {
        if (props.onClick instanceof Function) {
            props.onClick();
        }
    }

    return (
        <div className={"main-nav-item-view "+className} data-point={point}>
            <NavLink
                className="main-nav-item"
                to={!hasChildren && props.to}
                activeRoutes={activeRoutes}
                activeClassName="active-item"
                onClick={hasChildren ? toggleDropdown : handleOnClick}>
                <span clickable={props.id} { ...labelDataPoint }>{props.label}</span>
                {hasChildren && <SVGAsset id="DropdownIcon" className="dropdown-icon" { ...menuItemIconDataPoint } />}
            </NavLink>

            {dropdown &&
                <div>
                    <BrandingStyle style={{
                        "backgroundColor": "sub_nav_bg_abi22",
                        "borderColor": "sub_nav_bg_abi22",
                        "color":"nav_dd_text_abi22"
                    }} className="main-nav-dropdown flex-container flex-vertical" >
                      
                            {props.children}
                       
                    </BrandingStyle>


                    <div className="main-nav-overlay" onClick={() => setDropdown(!dropdown)}></div>
                </div>}
        </div>
    );
}

function SubNavSubItem(props) {

    const point = props["data-point"] ? props["data-point"] : props.datapoint ?? "";
    const additionalRoutes = props.activeRoutes ?? [];
    const className = props["custom-class"] ?? "";
    const [dropdown, setDropdown] = useState(false);
    const toggleDropdown = () => setDropdown(!dropdown);

   
    let activeRoutes =[];//CCTM_parse.getActiveRoutes(props)
    const hasChildren = React.Children.count(props.children) > 0;
    activeRoutes = activeRoutes.concat(additionalRoutes);

    return (
        // the class .sub-nav-open needs to be toggled on the div with class of .flyout-container -- it applies branding colors for selected navigation
        <div className={`flyout-container menu-nav-item-accordion ${dropdown?"sub-nav-open":""} ${className}` }>
            <div className="main-nav-item-view sub-item-container custom-accordion-toggle" data-point={point}>
                <NavLink
                    className="main-nav-menu-item-view flex-container align-center "
                    to={!hasChildren && props.to}
                    activeRoutes={activeRoutes}
                    activeClassName="active-item"
                    onClick={hasChildren ? toggleDropdown : () => undefined}>
                    <span class="menu-item-label flex-width" clickable={props.id}>{props.label}</span>
                    {hasChildren && <SVGAsset id="RightChevronIcon" />}

                </NavLink>

                {dropdown &&
                    <div class="custom-accordion-content main-nav-custom">
                        <BrandingStyle style={{
                            "backgroundColor": "sub_nav_bg_abi22",
                            "borderColor": "sub_nav_bg_abi22"
                        }} className="main-nav-dropdown flex-container flex-vertical" >
                            <div className="">
                                {props.children}
                            </div>
                        </BrandingStyle>



                    </div>
                }
            </div>
        </div>
    );
}

/**
 * @name MainNavMenuItem
 * @function
 * @extends React.Component
 * @exported false
 * @description Child nav item of the *MainNavItem* component
 * @param {STRING} label - Text of the link
 * @param {STRING} route - The route that should occur on click
 * @param {STRING} data-point - The point that should be added to the MainNavMenuItem
 * @example
 * <MainNavItem label="Link B">
 *  <MainNavMenuItem label="Sub Link A" route="/Path" />
 * </MainNavItem>
 */
function MainNavMenuItem(props) {
  
    const className = props["custom-class"] ?? "";
    let route = props.route??props.to
    const point = props["data-point"] ?props["data-point"] : props.datapoint ?? "";
    const labelDataPoint = point ? { "data-point": `${ point}_Label` } : {};

if (props.target !== "window"){
 return (
        <NavLink to={ route } onClick={ props.onClick } className={className}>
            <div className="main-nav-menu-item-view" data-point={ point } clickable={props.id}>
                <span { ...labelDataPoint }>{ props.label  }</span>
            </div>
        </NavLink>
    );
}

let onClick = ()=>{
       props.onClick();
}
return (
    
    <NavLink to={ false } onClick={ onClick } className={className}>
        <div className="main-nav-menu-item-view" data-point={ point } clickable={props.id}>
            <span { ...labelDataPoint }>{ props.label }</span>
        </div>
    </NavLink>
);

}

